import { Expense, Project } from 'static/classes/Accounting';
import { CSVPrinter } from 'static/classes/CSVPrinter';
import { COST_CENTER, DATEVK_KEY, DATEVW_KEY, VAT_KEY } from 'static/common/constants';
import { Modal } from 'bootstrap';

export function ExpensesViewModel(data) {
	var self = this;
	self.type = "ExpensesViewModel";

	self.rootvm = data.rootvm;
	self.web_host = data.rootvm.web_host;

	// constants
	self.DATEVK_KEY = DATEVK_KEY;
	self.DATEVW_KEY = DATEVW_KEY;
	self.VAT_KEY = VAT_KEY;
	self.COST_CENTER = COST_CENTER;

	// TOOD: check if needed
	self.csvprint = new CSVPrinter(data);

	self.is_busy = ko.observable(false);

	self.initialize = function () {
		self.is_busy(true);
		self.lookup_expenses().then((expenses) => {
			self.expenses(expenses.map(expense => new Expense(expense)));
			self.is_busy(false);
		}).catch((error) => {
			notyf.error(error);
			console.error(error);
		}).finally(() => {
			self.is_busy(false);
		});
		self.lookup_projects().then((projects) => {
			self.projects(projects.map(project => new Project(project)));
			self.is_busy(false);
		}).catch((error) => {
			notyf.error(error);
			console.error(error);
		}).finally(() => {
			self.is_busy(false);
		});
	}

	self.lookup_projects = async () => {
		const response = await fetch(self.web_host + '/api/admin/projects', { headers: { 'Accept': 'application/json' } });
		const data = await response.json();
		if (data.success) {
			return data.projects
		} else {
			throw new Error(data.message)
		}
	};
	self.include_deleted_expenses = ko.observable(false);
	self.include_deleted_expenses.subscribe(() => {
		self.is_busy(true);
		self.lookup_expenses().then((expenses) => {
			self.expenses(expenses.map(expense => new Expense(expense)));
		}).catch((error) => {
			notyf.error(error);
			console.error(error);
		}).finally(() => {
			self.is_busy(false);
		});
	});
	self.lookup_expenses = async () => {
		const searchParams = new URLSearchParams({
			'include_deleted': self.include_deleted_expenses()
		});
		const response = await fetch(
			`${self.web_host}/api/admin/expenses?${searchParams}`,
			{ headers: { 'Accept': 'application/json' }, searchParams }
		);
		const data = await response.json();
		if (data.success) {
			return data.expenses
		} else {
			console.error(data.pgcode, data.pgerror);
			throw new Error(data.message)
		}
	};

	self.projects = ko.observableArray([]);

	self.expenses = ko.observableArray([]);
	self.expenses.subscribe((expenses) => {
		self.oldest_exepense(expenses.reduce(
			(e1, e2) => (e1?.date && e2?.date) ?
				new Date(e1.date()) < new Date(e2.date()) ?
					e1 : e2
				: e1
		))
		self.newest_exepense(expenses.reduce(
			(e1, e2) => (e1?.date && e2?.date) ?
				new Date(e1.date()) > new Date(e2.date()) ?
					e1 : e2
				: e1
		))
		self.filter_start_date(self.oldest_exepense().date());
		self.filter_end_date(self.newest_exepense().date());
	});
	self.oldest_exepense = ko.observable(new Expense());
	self.newest_exepense = ko.observable(new Expense());
	self.reset_filter_date = () => {
		self.filter_start_date(self.oldest_exepense().date());
		self.filter_end_date(self.newest_exepense().date());
	}
	// for adding a new expense
	self.new_expense = ko.observable(new Expense());
	// for editing a existing expense
	self.selected_expense = ko.observable(new Expense());
	self.edit_expense = ko.observable(new Expense());

	self.add_expense = () => {
		self.is_busy(true);

		return $.ajax({

			url: self.web_host + '/api/admin/add-expense',
			type: 'POST',
			data: ko.toJSON({
				asp: self.new_expense().asp(),
				receiver_name: self.new_expense().receiver_name(),
				invoice_number: self.new_expense().invoice_number(),
				receipt: self.new_expense().receipt(),
				rs_number: self.new_expense().rs_number(),
				fee_number: self.new_expense().fee_number(),
				date: self.new_expense().is_fee() ? undefined : self.new_expense().date(),
				amount: self.new_expense().amount(),
				datevk: self.new_expense().datevk(),
				vat_id: self.new_expense().vat_id(),
				cost_center: self.new_expense().cost_center(),
				paid_details: self.new_expense().paid_details(),
				cloud_link: self.new_expense().cloud_link(),
				extra_notes: self.new_expense().extra_notes(),
				project_uuid: self.new_expense().project_uuid(),
				is_fee: self.new_expense().is_fee()
			}),
			processData: false,
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (data.success) {
					data.expense.project_title = self.projects().find((item) => item.project_uuid() === self.new_expense().project_uuid())?.title() ?? '';
					self.expenses.unshift(new Expense(data.expense));
					self.new_expense(new Expense());
					notyf.success("Added!");
				}
				else {
					notyf.error(data.message);
				}
			},
			error: function (jqXHR, errorStatus, thrownError) {
				var response = jQuery.parseJSON(jqXHR.responseText);
				notyf.error(response.message);
			},
			complete: () => self.is_busy(false)
		})
	};

	self.delete_expense = (expense) => {
		if (confirm('are you sure you want to delete? ')) {
			self.is_busy(true);
			return $.ajax({

				url: self.web_host + '/api/admin/delete-expense',
				type: 'POST',
				data: ko.toJSON({
					expense_uuid: expense.expense_uuid(),
				}),
				processData: false,

				contentType: "application/json; charset=utf-8",

				success: function (data) {

					if (data.success) {
						self.expenses.remove(expense);
						notyf.success("Removed!");
					}
					else {
						notyf.error(data.message);
					}

				},
				error: function (jqXHR, errorStatus, thrownError) {
					var response = jQuery.parseJSON(jqXHR.responseText);
					notyf.error(response.message);
				},
				complete: () => self.is_busy(false)
			})
		}
	};

	self.toggle_is_processed = (expense) => {
		const confirmMsg = expense.is_processed() ? 'Willst du den Eintrag als NICHT bearbeitet markieren?' : 'Willst du den Eintrag als bearbeitet markieren?';
		if (confirm(confirmMsg)) {
			self.is_busy(true);
			return $.ajax({

				url: self.web_host + '/api/admin/expense/toggle-is-processed',
				type: 'POST',
				data: ko.toJSON({
					expense_uuid: expense.expense_uuid(),
				}),
				processData: false,

				contentType: "application/json; charset=utf-8",

				success: function (data) {
					if (data.success) {
						self.expenses().map(expense => {
							if (expense.expense_uuid() === data.expense.expense_uuid)
								expense.is_processed(!expense.is_processed())
						})
						const successMsg = data.expense.is_processed ? 'Marked as processed' : 'Marked as NOT processed'
						notyf.success(successMsg);
					}
					else {
						notyf.error(data.message);
					}

				},
				error: function (jqXHR, errorStatus, thrownError) {
					var response = jQuery.parseJSON(jqXHR.responseText);
					notyf.error(response.message);
				},
				complete: () => self.is_busy(false)
			})
		}
	};

	self.set_selected_expense = (expense, lookup_invoice = false) => {
		//self.edit_expense(expense);
		data = ko.toJS(expense);
		self.selected_expense(expense);
		self.edit_expense(new Expense(data));
		//self.selected_expense(new Expense({... expense}));
		if (lookup_invoice) {
			self.edit_expense().lookup_invoice().catch((err) => {
				self.edit_expense().is_busy(false);
				console.error(err);
			});
		}
	}

	self.save_expense = () => {
		self.is_busy(true);
		return $.ajax({

			url: self.web_host + '/api/admin/edit-expense',
			type: 'POST',
			data: ko.toJSON({
				expense_uuid: self.edit_expense().expense_uuid(),
				asp: self.edit_expense().asp(),
				receiver_name: self.edit_expense().receiver_name(),
				invoice_number: self.edit_expense().invoice_number(),
				receipt: self.edit_expense().receipt(),
				rs_number: self.edit_expense().rs_number(),
				date: self.edit_expense().date(),
				amount: self.edit_expense().amount(),
				datevk: self.edit_expense().datevk(),
				datevw: self.edit_expense().datevw(),
				vat_id: self.edit_expense().vat_id(),
				cost_center: self.edit_expense().cost_center(),
				paid_details: self.edit_expense().paid_details(),
				cloud_link: self.edit_expense().cloud_link(),
				extra_notes: self.edit_expense().extra_notes(),
				project_uuid: self.edit_expense().project_uuid()
			}),
			processData: false,
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (data.success) {
					self.edit_expense().fee_invoice(self.selected_expense().fee_invoice());
					self.edit_expense().project_title(self.projects().find((item) => item.project_uuid() === self.edit_expense().project_uuid())?.title() ?? '');
					self.expenses.replace(self.selected_expense(), self.edit_expense());
					const editExpenseModal = document.getElementById('editExpenseModal');
					Modal.getInstance(editExpenseModal).hide();
					window.notyf.success("Saved!");
				}
				else {
					notyf.error(data.message);
				}
			},
			error: function (jqXHR, errorStatus, thrownError) {
				var response = jQuery.parseJSON(jqXHR.responseText);
				notyf.error(response.message);
			},
			complete: () => {
				self.is_busy(false);
			}
		})
	}

	// filter items
	self.filter_invoice_no = ko.observable('');
	self.filter_receiver_name = ko.observable('');
	self.filter_project_title = ko.observable('');
	self.filter_asp = ko.observable('');
	self.filter_receipt = ko.observable('');
	self.filter_datevk = ko.observable('');
	self.filter_datevw = ko.observable('');
	self.filter_cost_center = ko.observable('');
	self.filter_paid_details = ko.observable('');
	self.filter_extra_notes = ko.observable('');
	self._filter_start_date = ko.observable(new Date('2000-01-01'));
	self.filter_start_date = ko.pureComputed({
		read: function () {
			const date = self._filter_start_date();
			return date instanceof Date ? date.toLocaleDateString('en-CA') : ''; // en-CA uses YYYY-MM-DD
		},
		write: function (value) {
			const parsed = new Date(value);
			if (!isNaN(parsed)) {
				self._filter_start_date(parsed);
			}
		}
	});
	self.filter_end_date = ko.observable();
	self.filtered_items = ko.pureComputed(() =>
		self.expenses().filter((item) => {
			// date
			let result_filter_date = true;
			if(self.filter_start_date() && self.filter_end_date()) {
				result_filter_date = item.date_moment_obj.isBetween(self.filter_start_date(), self.filter_end_date(), 'day', '[]')
			}
			// invoice_number + is not fee
			let result_filter_invoice_no = true;
			if(self.filter_invoice_no() && !item.is_fee()) {
				result_filter_invoice_no = item.invoice_number().toLowerCase().includes(self.filter_invoice_no().toLowerCase())
			}
			// invoice_number + is fee
			if(self.filter_invoice_no() && item.is_fee()) {
				result_filter_invoice_no = (`F${item.fee_number().toString()}`).toLowerCase().includes(self.filter_invoice_no().toLowerCase())
			}
			// receiver_name
			let result_filter_receiver_name = true;
			if(self.filter_receiver_name()) {
				result_filter_receiver_name = item.receiver_name().toLowerCase().includes(self.filter_receiver_name().toLowerCase())
			}
			// project_title
			let result_filter_project_title = true;
			if(self.filter_project_title()) {
				result_filter_project_title = item.project_title().toLowerCase().includes(self.filter_project_title().toLowerCase())
			}
			// asp
			let result_filter_asp = true;
			if(self.filter_asp()) {
				result_filter_asp = item.asp()?.toLowerCase().includes(self.filter_asp().toLowerCase())
			}
			// receipt
			let result_filter_receipt = true;
			if(self.filter_receipt()) {
				result_filter_receipt = item.receipt()?.toLowerCase().includes(self.filter_receipt().toLowerCase())
			}
			// datevk
			let result_filter_datevk = true;
			if(self.filter_datevk()) {
				result_filter_datevk = item.datevk()?.toLowerCase().includes(self.filter_datevk().toLowerCase())
			}
			// datevw
			let result_filter_datevw = true;
			if(self.filter_datevw()) {
				result_filter_datevw = item.datevw()?.toLowerCase().includes(self.filter_datevw().toLowerCase())
			}
			// cost_center
			let result_filter_cost_center = true;
			if(self.filter_cost_center()) {
				result_filter_cost_center = item.cost_center().toLowerCase().includes(self.filter_cost_center().toLowerCase())
			}
			// paid_details
			let result_filter_paid_details = true;
			if(self.filter_paid_details()) {
				result_filter_paid_details = item.paid_details()?.toLowerCase().includes(self.filter_paid_details().toLowerCase())
			}
			// extra_notes
			let result_filter_extra_notes = true;
			if(self.filter_extra_notes()) {
				result_filter_extra_notes = item.extra_notes()?.toLowerCase().includes(self.filter_extra_notes().toLowerCase())
			}

			return result_filter_date && result_filter_invoice_no && result_filter_receiver_name && result_filter_project_title && result_filter_asp && result_filter_receipt && result_filter_datevk && result_filter_datevw && result_filter_cost_center && result_filter_paid_details && result_filter_extra_notes
		})
	);
	self.filtered_items.subscribe(() => {
		self.page_current(1);
	});


	// pagination
	self.items_per_page = ko.observable(100);
	self.items_per_page_options = [5, 15, 30, 50, 100, 200];
	self.items_per_page.subscribe(() => {
		self.page_current(1);
	});
	self.first_item = ko.pureComputed(() => (self.page_current() - 1) * self.items_per_page());
	self.last_item = ko.pureComputed(() => self.page_current() * self.items_per_page());
	self.total_count = ko.pureComputed(() => self.expenses()?.length);
	self.filtered_count = ko.pureComputed(() => self.filtered_items()?.length);
	self.page_current = ko.observable(1);
	self.pages_total = ko.pureComputed(() => Math.ceil(self.filtered_count() / self.items_per_page()));
	self.paged_items = ko.pureComputed(() => self.filtered_items().slice(self.first_item(), self.last_item()));
};
